export interface APRData {
  apr: number;
  apy: number;
  cronSchedule: string;
  lastDistributedAmount: string;
  lastDistributionTimestamp: string;
}

export async function fetchAPRData(): Promise<APRData> {
  try {
    const response = await fetch("/api/apr", {
      method: "GET",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching APR data:", error);
    throw error;
  }
}

// Fallback function that returns a default APR if the API fails
export function getDefaultAPR(): APRData {
  return {
    apy: 30,
    apr: 30,
    cronSchedule: "*/30 * * * * *",
    lastDistributedAmount: "0",
    lastDistributionTimestamp: new Date().toISOString(),
  };
}
